import React, {Fragment} from 'react';
import {data} from "../../store/data";
import Media from "react-media/index";
import FullPage from "./FullPage";
import MiniPage from "./MiniPage";
import {Button} from "reactstrap";
import Paper from "./Paper";
import Header from "../Header";
import {
	IMAGES_DIR,
	LG_BREAKPOINT,
	RESUME,
	RESUME_COMPONENT_NAV_ITEMS,
	resume_download_link
} from "../../Constants/Constants";
import Footer from "../Footer";
import {PURPLE_GRADIENT_TO_RIGHT} from "../../Constants/Colors";

class Resume extends React.Component {
	constructor(props) {
		super(props);
		//console.log("In Resume Component:", this.props.location);
		this.state = {
			data: data,
			print: false,
			navbarHeight: 0,
			navbarWidth: 0,
			references: {}
		};
		this.printResume = this.printResume.bind(this);
		this.componentRef = React.createRef();
		//console.log("Resume Constructor");
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		this.updateRef(RESUME, this.componentRef);
		this.updateRef("main", this.componentRef);
		// .then((res)=>//console.log("state Updated", res))
		// .catch(err=>//console.log(err));
	}

	updateRef(title, value) {
		//console.log("UpdateRef, Called for ", title, value);
		this.setState((state) => {
			let newState = {...state};//deepCopy(state);
			newState.references[title] = value;
			//Object.assign({[title]: value}, this.state.references);
			//console.log("Before Update Ref", state);
			return newState;
		});
	}

	printResume() {
		this.setState({print: true}, () => {
			window.print();
		});
	}

	updateNavbarHeight(height) {
		this.setState({navbarHeight: height})
	}

	updateNavbarWidth(width) {
		this.setState({navbarWidth: width})
	}

	styles = {
		floatingActionMenu: {
			floatingActionButton: {
				color: "white",
				backgroundImage: PURPLE_GRADIENT_TO_RIGHT,
				// backgroundColor: "#7E57C2",
				// boxShadow: "0 0 5px 3px #fff",
				border: "1px solid #7E57C2",
				borderRadius: "10em",
				// padding: "1rem",
				margin: "1vmin"
			},
			display: 'flex',
			flexDirection: "row",
			top: "0.5rem",
			right: "1rem",
			position: 'fixed',
			zIndex: 100000,
			small: {
				display: 'flex',
				flexDirection: "column",
				bottom: "1rem",
				right: "1rem",
				position: 'fixed',
				zIndex: 100000
			}
		},
		navbar: {
			small: {
				zIndex: 10000,
				position: 'fixed',
				top: 0,
				width: "100%",
				// backgroundColor: "fff",
				// background: "url(" + IMAGES_DIR + "/home.jpg)",
				// backgroundImage: PURPLE_GRADIENT_TO_RIGHT,
				image: {
					height: "40px",
					alignSelf: "center",
					// margin: "auto"
				},
				navItemsContainer: {
					float: "right",
					maxWidth: "50vw",
					padding: "1rem",
					textAlign: "right",
					backgroundImage: PURPLE_GRADIENT_TO_RIGHT
				}
			},
			padding: 0,
			// backgroundColor: "#311B92",
			backgroundImage: PURPLE_GRADIENT_TO_RIGHT,
			color: 'white',
			position: 'fixed',
			top: 0,
			// height:"100vh",
			width: "100%",
			zIndex: 100000,
			// flexDirection: "column",
			// alignItems: "center",
			justifyContent: "space-around",
			image: {
				height: "3rem",
				alignSelf: "center",
				margin: "auto"
			},
			navItemsContainer: {
				zIndex: 100000,
				paddingRight: "10px",
				flexDirection: "row",
				navbarItem: {
					// fontSize: "2rem",
					fontWeight: 300,
					textDecoration: "none"
				}
			},
		}
	};

	render() {
		const paper = (
			<Fragment>
				<Paper data={this.state.data} window_width={this.props.window_width} window_height={this.props.window_height}/>
			</Fragment>
		);
		// return paper;
		if (this.state.print) {
			return paper;
		}

		const floatingActionButtons = (
			<Fragment>
				<Button color="success" style={this.styles.floatingActionMenu.floatingActionButton} onClick={this.printResume}>
					<span className="fa fa-print"></span>
				</Button>
			</Fragment>
		)

		return (
			<div ref={this.componentRef} style={{background: "url(" + IMAGES_DIR + "/home.jpg)"}}>
				<Header
					changeNavbarColorOnScroll
					parentName={"resume"}
					key={"resume-header"}
					window_width={this.props.window_width}
					window_height={this.props.window_height}
					styles={this.styles.navbar}
					navItems={RESUME_COMPONENT_NAV_ITEMS}
					updateNavbarHeight={(height) => this.updateNavbarHeight(height)}
					references={this.state.references}
				/>
				<div style={{paddingTop: this.state.navbarHeight, position: "relative"}} id="main">
					<Media query={"(min-width: " + LG_BREAKPOINT + "px )"}>
						{
							matches => matches
								? (
									<Fragment>
										<div style={this.styles.floatingActionMenu}>
											{floatingActionButtons}
										</div>
										<FullPage data={this.state.data} window_width={this.props.window_width}
															window_height={this.props.window_height}/>
									</Fragment>
								) : (
									<Fragment>
										<div style={this.styles.floatingActionMenu.small}>
											{floatingActionButtons}
										</div>
										<MiniPage data={this.state.data} window_width={this.props.window_width}
															window_height={this.props.window_height}/>
									</Fragment>
								)
						}
					</Media>
				</div>
				<Footer/>
			</div>
		);
	}
}

export default Resume;